(function () {
  var TOOL_SELECTOR = "[data-sb-footprint]";
  var ELIGIBLE_NARROW_SIZES = [9, 12, 14];
  var SUPPORTED_SIZES = [9, 12, 14, 16, 18, 20, 22];
  var BOARD_WEIGHTS = {
    standard: {
      9: 153,
      12: 218,
      14: 256,
      16: 294,
      18: 340,
      20: 386,
      22: 420
    },
    narrow: {
      9: 96,
      12: 134,
      14: 160
    }
  };
  var TECHNICAL_IMAGE_URLS = {
    standard: {
      9: "https://mccluretables.com/cdn/shop/files/9x32.jpg",
      12: "https://mccluretables.com/cdn/shop/files/12x32.jpg",
      14: "https://mccluretables.com/cdn/shop/files/14x32.jpg",
      16: "https://mccluretables.com/cdn/shop/files/16x32.jpg",
      18: "https://mccluretables.com/cdn/shop/files/18x32.jpg",
      20: "https://mccluretables.com/cdn/shop/files/20x32.jpg",
      22: "https://mccluretables.com/cdn/shop/files/22x32.jpg"
    },
    narrow: {
      9: "https://mccluretables.com/cdn/shop/files/9x26.jpg",
      12: "https://mccluretables.com/cdn/shop/files/12x26.jpg",
      14: "https://mccluretables.com/cdn/shop/files/14x26.jpg"
    }
  };

  function inchesToFeetString(totalInches) {
    var feet = Math.floor(totalInches / 12);
    var inches = totalInches % 12;

    if (inches === 0) {
      return feet + " ft";
    }

    return feet + " ft " + inches + " in";
  }

  function inchesToFractionString(totalInches) {
    if (Number.isInteger(totalInches)) {
      return totalInches + " in";
    }

    return totalInches.toFixed(1).replace(/\.0$/, "") + " in";
  }

  function getApproximateWeight(config) {
    var mode = config.isNarrow ? "narrow" : "standard";
    return BOARD_WEIGHTS[mode][config.tableFeet];
  }

  function getTypicalConfigurationText(config) {
    if (config.tableFeet >= 16) {
      return "Larger tables are often built in sections for easier access and installation, though cabinet construction may vary by model.";
    }

    if (config.isNarrow) {
      return "Smaller narrow-footprint tables are often simpler to place, though cabinet construction may vary by model and custom builds may use additional sections.";
    }

    return "Smaller and mid-size tables are typically straightforward to place, though cabinet construction may vary by model and some builds may use additional sections.";
  }

  function createSvgMarkup(config, options) {
    var cabinetLength = config.cabinetLength;
    var cabinetWidth = config.cabinetWidth;
    var playboardLength = config.playboardLength;
    var playboardWidth = config.playboardWidth;
    var topPadding = options.annotated ? 22 : 12;
    var bottomPadding = options.annotated ? 10 : 8;
    var leftPadding = 10;
    var rightPadding = options.annotated ? 18 : 10;
    var viewBoxWidth = cabinetLength + leftPadding + rightPadding;
    var viewBoxHeight = cabinetWidth + topPadding + bottomPadding;
    var cabinetX = leftPadding;
    var cabinetY = topPadding;
    var playboardX = cabinetX + (cabinetLength - playboardLength) / 2;
    var playboardY = cabinetY + (cabinetWidth - playboardWidth) / 2;
    var cornerRadius = Math.min(cabinetWidth * 0.18, 8);
    var title = config.label + " shuffleboard footprint";
    var subtitle = config.widthLabel.toLowerCase() + " cabinet";
    var cabinetDimensionY = cabinetY - 7;
    var widthDimensionX = cabinetX + cabinetLength + 5;
    var textColor = "#5c554d";
    var titleMarkup = options.annotated
      ? '<text x="' + cabinetX + '" y="9" font-family="Arial, sans-serif" font-size="6.2" fill="#181614">' + escapeXml(title) + "</text>" +
        '<text x="' + cabinetX + '" y="15" font-family="Arial, sans-serif" font-size="4.2" fill="' + textColor + '">' + escapeXml(subtitle) + "</text>"
      : "";
    var annotationMarkup = options.annotated
      ? [
          '<line x1="' + cabinetX + '" y1="' + cabinetDimensionY + '" x2="' + (cabinetX + cabinetLength) + '" y2="' + cabinetDimensionY + '" stroke="#8a4b2c" stroke-width="0.7" />',
          '<line x1="' + cabinetX + '" y1="' + (cabinetDimensionY - 3) + '" x2="' + cabinetX + '" y2="' + (cabinetDimensionY + 3) + '" stroke="#8a4b2c" stroke-width="0.7" />',
          '<line x1="' + (cabinetX + cabinetLength) + '" y1="' + (cabinetDimensionY - 3) + '" x2="' + (cabinetX + cabinetLength) + '" y2="' + (cabinetDimensionY + 3) + '" stroke="#8a4b2c" stroke-width="0.7" />',
          '<text x="' + (cabinetX + cabinetLength / 2) + '" y="' + (cabinetDimensionY - 4.5) + '" text-anchor="middle" font-family="Arial, sans-serif" font-size="5" fill="#8a4b2c">' + escapeXml(inchesToFeetString(cabinetLength)) + "</text>",
          '<line x1="' + widthDimensionX + '" y1="' + cabinetY + '" x2="' + widthDimensionX + '" y2="' + (cabinetY + cabinetWidth) + '" stroke="#8a4b2c" stroke-width="0.7" />',
          '<line x1="' + (widthDimensionX - 3) + '" y1="' + cabinetY + '" x2="' + (widthDimensionX + 3) + '" y2="' + cabinetY + '" stroke="#8a4b2c" stroke-width="0.7" />',
          '<line x1="' + (widthDimensionX - 3) + '" y1="' + (cabinetY + cabinetWidth) + '" x2="' + (widthDimensionX + 3) + '" y2="' + (cabinetY + cabinetWidth) + '" stroke="#8a4b2c" stroke-width="0.7" />',
          '<text x="' + (widthDimensionX + 10) + '" y="' + (cabinetY + cabinetWidth / 2) + '" font-family="Arial, sans-serif" font-size="5" fill="#8a4b2c" transform="rotate(90 ' + (widthDimensionX + 10) + " " + (cabinetY + cabinetWidth / 2) + ')">' + escapeXml(inchesToFractionString(cabinetWidth)) + "</text>"
        ].join("")
      : "";

    return [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + viewBoxWidth + " " + viewBoxHeight + '" role="img" aria-label="' + escapeXml(title) + '">',
      '<rect x="0" y="0" width="' + viewBoxWidth + '" height="' + viewBoxHeight + '" fill="#f7f2ea" />',
      titleMarkup,
      '<rect x="' + cabinetX + '" y="' + cabinetY + '" width="' + cabinetLength + '" height="' + cabinetWidth + '" rx="' + cornerRadius + '" fill="#d8cec1" stroke="#7f6f5e" stroke-width="1.2" />',
      '<rect x="' + playboardX + '" y="' + playboardY + '" width="' + playboardLength + '" height="' + playboardWidth + '" rx="' + Math.min(playboardWidth * 0.14, 4) + '" fill="#8f6944" stroke="#5a4028" stroke-width="0.9" />',
      annotationMarkup,
      "</svg>"
    ].join("");
  }

  function getTechnicalImageUrl(config) {
    var mode = config.isNarrow ? "narrow" : "standard";
    var imageMap = TECHNICAL_IMAGE_URLS[mode] || {};
    return imageMap[config.tableFeet] || "";
  }

  function escapeXml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function filenameFor(config, variant) {
    return [
      "shuffleboard",
      config.tableFeet + "ft",
      config.isNarrow ? "narrow" : "standard",
      variant
    ].join("-") + ".svg";
  }

  function buildSvgAssets(config) {
    return {
      preview: createSvgMarkup(config, { annotated: true }),
      downloads: {
        annotated: {
          markup: createSvgMarkup(config, { annotated: true }),
          filename: filenameFor(config, "annotated")
        },
        clean: {
          markup: createSvgMarkup(config, { annotated: false }),
          filename: filenameFor(config, "clean")
        }
      }
    };
  }

  function buildConfig(root) {
    var standardWidth = Number(root.dataset.standardWidth);
    var narrowWidth = Number(root.dataset.narrowWidth);
    var standardPlayboardWidth = Number(root.dataset.standardPlayboardWidth);
    var narrowPlayboardWidth = Number(root.dataset.narrowPlayboardWidth);
    var playboardLengthOffset = Number(root.dataset.playboardLengthOffset);
    var checkedSize = root.querySelector('input[type="radio"]:checked');
    var narrowToggle = root.querySelector("[data-narrow-toggle]");
    var tableFeet = Number(checkedSize.value);
    var canUseNarrow = ELIGIBLE_NARROW_SIZES.indexOf(tableFeet) !== -1;
    var isNarrow = canUseNarrow && narrowToggle.checked;
    var cabinetLength = tableFeet * 12;
    var cabinetWidth = isNarrow ? narrowWidth : standardWidth;

    return {
      tableFeet: tableFeet,
      label: tableFeet + " ft table",
      canUseNarrow: canUseNarrow,
      isNarrow: isNarrow,
      widthLabel: isNarrow ? "Narrow" : "Standard",
      cabinetLength: cabinetLength,
      cabinetWidth: cabinetWidth,
      cabinetHeight: 32,
      playboardLength: cabinetLength - playboardLengthOffset,
      playboardWidth: isNarrow ? narrowPlayboardWidth : standardPlayboardWidth
    };
  }

  function applyDownloadLink(link, svgMarkup, filename) {
    var encoded = encodeURIComponent(svgMarkup);
    link.href = "data:image/svg+xml;charset=utf-8," + encoded;
    link.setAttribute("download", filename);
  }

  function getRequestedSize() {
    var params = new URLSearchParams(window.location.search);
    var size = Number(params.get("size"));

    if (SUPPORTED_SIZES.indexOf(size) === -1) {
      return null;
    }

    return size;
  }

  function applyRequestedSize(root) {
    var requestedSize = getRequestedSize();

    if (!requestedSize) {
      return;
    }

    var matchingInput = root.querySelector('input[type="radio"][value="' + requestedSize + '"]');

    if (matchingInput) {
      matchingInput.checked = true;
    }
  }

  function render(root) {
    var config = buildConfig(root);
    var preview = root.querySelector("[data-preview]");
    var title = root.querySelector("[data-preview-title]");
    var narrowToggle = root.querySelector("[data-narrow-toggle]");
    var toggleWrapper = narrowToggle.closest(".sb-footprint__toggle");
    var widthNote = root.querySelector("[data-width-note]");
    var technicalPreview = root.querySelector("[data-technical-preview]");
    var cleanDownload = root.querySelector("[data-download-clean]");
    var annotatedDownload = root.querySelector("[data-download-annotated]");
    var svgAssets = buildSvgAssets(config);
    var technicalImageUrl;

    if (!config.canUseNarrow) {
      narrowToggle.checked = false;
      narrowToggle.disabled = true;
      toggleWrapper.classList.add("is-disabled");
      widthNote.textContent = "Narrow cabinet is only available for 9 ft, 12 ft, and 14 ft tables.";
      config = buildConfig(root);
    } else {
      narrowToggle.disabled = false;
      toggleWrapper.classList.remove("is-disabled");
      widthNote.textContent = config.isNarrow
        ? "Narrow cabinet selected for this footprint."
        : "Available for 9 ft, 12 ft, and 14 ft tables.";
    }

    svgAssets = buildSvgAssets(config);
    technicalImageUrl = getTechnicalImageUrl(config);

    title.textContent = config.label + " - " + config.widthLabel.toLowerCase() + " cabinet";
    preview.innerHTML = svgAssets.preview;

    if (technicalPreview) {
      if (technicalImageUrl) {
        technicalPreview.innerHTML =
          '<img src="' + technicalImageUrl + '" alt="' + escapeXml(config.label + ' technical dimensions') + '" loading="lazy" class="sb-footprint__technical-image" />';
      } else {
        technicalPreview.innerHTML = "";
      }
    }

    root.querySelector("[data-cabinet-length]").textContent = inchesToFeetString(config.cabinetLength);
    root.querySelector("[data-cabinet-width]").textContent = inchesToFractionString(config.cabinetWidth);
    root.querySelector("[data-playboard-length]").textContent = inchesToFeetString(config.playboardLength);
    root.querySelector("[data-playboard-width]").textContent = inchesToFractionString(config.playboardWidth);
    root.querySelector("[data-access-length]").textContent = inchesToFeetString(config.playboardLength);
    root.querySelector("[data-access-weight]").textContent = getApproximateWeight(config) + " lbs";
    root.querySelector("[data-access-configuration]").textContent = getTypicalConfigurationText(config);

    applyDownloadLink(annotatedDownload, svgAssets.downloads.annotated.markup, svgAssets.downloads.annotated.filename);
    applyDownloadLink(cleanDownload, svgAssets.downloads.clean.markup, svgAssets.downloads.clean.filename);
  }

  function bindTool(root) {
    applyRequestedSize(root);

    root.addEventListener("change", function (event) {
      var target = event.target;

      if (target.matches('input[type="radio"]') || target.matches("[data-narrow-toggle]")) {
        render(root);
      }
    });

    render(root);
  }

  document.querySelectorAll(TOOL_SELECTOR).forEach(bindTool);
})();
